module.exports = __webpack_public_path__ + "static/OP12-ab345c80bf50546b3912246963e3fb0a.png";